import InfoIcon from '@mui/icons-material/Info';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormFieldNames } from '../../../validations/assignRfidCardValidationSchema';
import Alert from '../../Alert';
import RadioGroup from '../../HookFormFields/RadioGroup';
import messages from '../messages';

function RadioGroupCardType() {
  const { formatMessage } = useIntl();
  const { watch } = useFormContext();
  const isStandardCard = watch(FormFieldNames.CardType) === FormFieldNames.StandardCard;

  return (
    <>
      <RadioGroup name={FormFieldNames.CardType}>
        <FormControlLabel
          control={<Radio />}
          value={FormFieldNames.DormakabaCard}
          label={formatMessage(messages.userRfidModalCardDormakabaLabel)}
        />
        <Typography variant="caption" color="text.secondary" pl={4}>
          <FormattedMessage {...messages.userRfidModalCardDormakabaHelper} />
        </Typography>
        <FormControlLabel
          control={<Radio />}
          value={FormFieldNames.StandardCard}
          label={formatMessage(messages.userRfidModalCardNormalLabel)}
        />
        <Typography variant="caption" color="text.secondary" pl={4} pb={0}>
          <FormattedMessage {...messages.userRfidModalCardNormalHelper} />
        </Typography>
      </RadioGroup>
      {isStandardCard && (
        <Alert severity="warning" icon={<InfoIcon />}>
          <FormattedMessage {...messages.userRfidModalCardDormakabaAlert} />
        </Alert>
      )}
    </>
  );
}

export default RadioGroupCardType;
